export const ONE_SECOND = 1000;
// eslint-disable-next-line no-magic-numbers
export const ONE_MINUTE = ONE_SECOND * 60;
export const ONE = 1;
export const TWO = 2;
export const TEN = 10;
export const MINUS_ONE = -1;

export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};
